import React from 'react'
import HomeComponent from '../../components/home/HomeComponent'

export default function HomePage() {
  return (
    <div>
      <HomeComponent/>
    </div>
  )
}
